import React, { useState, useEffect, useContext } from 'react';
import DietPlanCard from './DietPlanCard';
import Feature from './Feature';
import PaymentHeader from './PaymentHeader';
import StepCarousal from './StepCarousal';
import joinUs from './join.png';
import { Link, useParams } from 'react-router-dom';
import { Button, Container } from 'reactstrap';
import { useDiet } from '../../../hooks/useDiet';
import { openTermsAndConditionWeb, sendFirebaseEvent } from '../../../helper/mobile';
import SuccessStories from '../DietPlanMain/SuccessStories';
import WeightChart from './weight-chart.svg';
import { AppContext } from '../../../context/app-context';

const price = {
    "one_month_diet_plan": "₹799",
    "three_month_diet_plan": "₹699",
    "six_month_diet_plan": "₹599"
}

const DietPayment = () => {

    const [state, dispatch] = useContext(AppContext);
    
    const [selectedPlan, setSelectedPlan] = useState('one_month_diet_plan');
    const [isDisplayTerms, setIsDisplayTerms] = useState(false);
    
    const { dietPlanId, isItUpgrade } = useParams();

    const { makeDietPayment } = useDiet();

    useEffect(() => {
        const osType = state?.user?.osType;
        const appVersionCodeNumber = parseInt(state?.user?.appVersionCode);
        if(osType === 'android') {
            if(appVersionCodeNumber > 91)
                setIsDisplayTerms(true);
        }else if(osType === 'iOS'){
            if(appVersionCodeNumber > 94) 
                setIsDisplayTerms(true);
        }
    }, []);

    const onCardClickHandler = (plan) => {
        sendFirebaseEvent('diet_plan_type_card', 'click_event', plan);
        setSelectedPlan(plan)
    }

    const onClickMakePayment = () => {
        const osType = state?.user?.osType;
        const appVersionCodeNumber = parseInt(state?.user?.appVersionCode);
        let selectedPlanConst = selectedPlan;
        if(osType === 'android') {
            if(appVersionCodeNumber >= 92) {
                selectedPlanConst = selectedPlanConst+'_subscription'
            }
        }else if(osType === 'iOS'){
            if(appVersionCodeNumber >= 95) {
                selectedPlanConst = selectedPlanConst+'_subscription'
            }
        }

        if(isItUpgrade === 'true'){
            sendFirebaseEvent('diet_plan_make_payment_btn', 'click_event', selectedPlanConst);
            makeDietPayment(selectedPlanConst, dietPlanId, null, true);
        }else {
            sendFirebaseEvent('diet_plan_make_payment_btn', 'click_event', selectedPlanConst);
            makeDietPayment(selectedPlanConst, dietPlanId);
        }
    }

    return( 
        <>
            <PaymentHeader />
            <DietPlanCard selectedPlan={selectedPlan} onCardClickHandler={onCardClickHandler} />
            <Container className='mb-4'>
                <h3 className='clients-lost mt-4 mb-3'><span>93%</span> of our users have seen a difference within <span>3 months</span></h3>
                <img className='weight-chart mb-2' src={WeightChart} alt="" />
            </Container>
            <StepCarousal />
            <SuccessStories />
            {/* <img src={joinUs} alt="" className='w-100' /> */}
            <div className="empty-space-117"></div>
            <div className="fix-div-button-payment text-center">
                <Button className="risk-btn" onClick={onClickMakePayment}>Make payment of {price[selectedPlan]}/month</Button>
                {isDisplayTerms && <p className='mb-0 mt-2 terms-and-condition-p text-muted'>
                    By making payment you agree to our <span onClick={openTermsAndConditionWeb}>T&C</span>
                </p> }
                {/* { isItUpgrade !== 'true' && <Link to="/dietPlan/ai" className='free-diet-plan-link' onClick={() => sendFirebaseEvent('diet_plan_dont_want_personalised_health', 'click_event')}>Not sure about payment? Try our AI plan</Link> } */}
            </div>
        </>
    );
}

export default DietPayment;
